import { gql } from "@apollo/client"
import { SCHEDULED_ACTION_FRAGMENT } from "@graphql"

const SAVE_EVENT_SCHEDULED_ACTION_MUTATION = gql`
  ${SCHEDULED_ACTION_FRAGMENT}

  mutation($input: SaveEventScheduledActionInput!) {
    saveEventScheduledAction(input: $input) {
      ...ScheduledActionFields
    }
  }
`

export { SAVE_EVENT_SCHEDULED_ACTION_MUTATION }